import { ColorBlock } from "@/components/colorblock/ColorBlock.tsx";
import { EmojiPickerDropdown } from "@/components/emoji/EmojiPickerDropdown.tsx";
import { limitedColors } from "@/components/emoji/limited-colors.ts";
import {
  Avatar,
  Box,
  Button,
  FontAwesomeIcon,
  Modal,
  ModalProps,
  Stack,
  toColorName,
  toCssColorValue,
  useModals,
} from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface TimeOffCategoryDecorationEditProps extends ModalProps {
  emoji: string;
  color: string;
  onSave: (emoji: string, color: string) => void;
}

export function EmojiAndColorEditModal({
  emoji,
  color,
  onSave,
  ...props
}: TimeOffCategoryDecorationEditProps) {
  const { t } = useTranslation();
  const { id } = props;
  const { close } = useModals();
  const [currentEmoji, setCurrentEmoji] = useState<string>(emoji);
  const [currentColor, setCurrentColor] = useState<string>(toColorName(color) ?? color ?? "blue");

  return (
    <Modal
      {...props}
      title={t("time_off:change_style")}
      withCloser
      actions={
        <Stack gap={"sm"}>
          <Button
            type={"submit"}
            size={"lg"}
            onClick={() => {
              onSave(currentEmoji, currentColor);
              close(id);
            }}
          >
            {t("common:save")}
          </Button>
        </Stack>
      }
    >
      <Stack gap={"2xl"}>
        <EmojiPickerDropdown
          onEmojiSelect={(em) => {
            setCurrentEmoji(em);
          }}
        >
          <Box
            className={"relative w-41 h-41 group cursor-pointer rounded-md bg-brand-dark/5"}
            style={{ backgroundColor: toCssColorValue(currentColor) }}
          >
            {currentEmoji && (
              <Avatar variant={"plain"} url={undefined} emoji={currentEmoji} size={"2xl"} />
            )}
            <Box
              className={
                "bg-dark/20 opacity-0 group-hover:opacity-100 absolute inset-0 rounded-md flex items-center justify-center"
              }
            >
              <FontAwesomeIcon icon={"fa-light fa-icons"} className={"text-[74px] text-light "} />
            </Box>
          </Box>
        </EmojiPickerDropdown>

        <Stack direction={"horizontal"} gap={"sm"}>
          {limitedColors.map((colorName) => (
            <ColorBlock
              key={colorName}
              color={colorName}
              size="md"
              selected={currentColor === colorName}
              onClick={() => setCurrentColor(colorName)}
            />
          ))}
        </Stack>
      </Stack>
    </Modal>
  );
}
